import {
  CardContent,
  CardMedia,
  Grid,
  Typography,
  Box,
  Button,
  CircularProgress,
} from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import SimpleCard from '../../../../../components/SimpleCard';
import VendorProfileFormModal from '../../../vendor-profile/components/Profile/VendorProfileFormModal';

export default function ProfileCard() {
  const { user, loading: loadingProfile } = useSelector((store) => store.users);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const handleClose = () => {
    setIsEditModalOpen(false);
  };

  return (
    <div>
      <Grid container justifyContent="center">
        <Grid item>
          <Typography fontWeight="bold">Vendor:</Typography>
        </Grid>
        <Grid item>
          <Typography marginLeft={2}>Tell us a little more about your company!</Typography>
        </Grid>
      </Grid>

      <SimpleCard variant="outlined">
        <CardContent>
          {loadingProfile ? (
            <CircularProgress />
          ) : (
            <Grid container>
              <Grid item xs={11}>
                <Grid container>
                  <Grid item>
                    <Typography fontWeight="bold">Company:</Typography>
                  </Grid>
                  <Grid item>
                    <Typography marginLeft={2}>{user.vendor_company_name || ''}</Typography>
                  </Grid>
                </Grid>
                <div>
                  <Typography fontWeight="bold">Business summary:</Typography>
                  <Typography>{user.vendor_business_desc || ''}</Typography>
                </div>
                <div>
                  <Typography fontWeight="bold">Product offered:</Typography>
                  <Typography>{user.vendor_product_desc || ''}</Typography>
                </div>
                <Grid style={{ display: 'flex', marginTop: '1rem' }}>
                  {user?.user_tags &&
                    user?.user_tags.map((userTag) => (
                      <Box
                        key={userTag?.fk_category}
                        sx={{
                          borderRadius: '17px',
                          backgroundColor: '#0997BA',
                          py: 1,
                          px: 2,
                          color: 'white',
                          justifyContent: 'center',
                          mr: 1,
                        }}>
                        {userTag?.category?.name}
                      </Box>
                    ))}
                </Grid>
              </Grid>
              <Grid item xs={1}>
                <Button
                  style={{ float: 'right' }}
                  variant="outlined"
                  size="small"
                  onClick={() => setIsEditModalOpen(true)}>
                  Edit
                </Button>
              </Grid>
            </Grid>
          )}
        </CardContent>
      </SimpleCard>
      <VendorProfileFormModal isOpen={isEditModalOpen} handleClose={handleClose} />
    </div>
  );
}
